import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl; 
const endpoint = '/api/infraestructura_carpetas';

const infraestructuraService = {
    getCarpetas: async () => {
        try {
            const response = await axios.get(`${baseUrl}${endpoint}`);
            return response.data; 
        } catch (error) {
            console.error('Error al obtener carpetas:', error);
            throw error;
        }
    },
    createCarpeta: async (data) => {
        try {
            const response = await axios.post(`${baseUrl}${endpoint}`, data);
            return response.data; 
        } catch (error) {
            console.error('Error al crear carpeta:', error);
            throw error;
        }
    },
    updateCarpeta: async (id, data) => {
        try {
            const response = await axios.put(`${baseUrl}${endpoint}/${id}`, data);
            return response.data; 
        } catch (error) {
            console.error('Error al actualizar carpeta:', error);
            throw error;
        }
    },
};

export default infraestructuraService;
